import React from "react";
import { UilTimes } from "@iconscout/react-unicons";
import PrimaryButton from "./PrimaryButton";
import { Button } from "@chakra-ui/react";
import classNames from "classnames";

const PopupWrapper = ({
  onClose,
  children,
  width,
  maxHeight = "max-h-[90svh]",
  heading,
  isShowAction,
  handleSubmit,
  padding = 6,
  bgColor = "bg-white",
  isDisbledSubmit = false,
  isHideHeading,
  isOverflow,
  isWidthAuto = false,

  aspectRatio,
}) => {
  return (
    // <div>
    <div className="fixed top-0 inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-40">
      <div
        style={{
          padding: `${padding * 4}px`,
          aspectRatio: aspectRatio || undefined,
        }}
        className={
          ` rounded-lg shadow-lg  min-h-0   relative z-[60]  ${isWidthAuto ? "w-auto" : "w-full"} ` +
          width +
          " " +
          bgColor
        }
      >
        <button
          onClick={onClose}
          className="absolute top-1 right-1 z-10 bg-gray-100 hover:bg-gray-200 rounded-full w-6 h-6 flex items-center justify-center"
          aria-label="Close"
        >
          <UilTimes className="w-5 h-5 text-gray-700" />
        </button>
        <div
          className={classNames(
            maxHeight,
            isOverflow && "overflow-y-auto min-h-0",
          )}
        >
          {heading && (
            <h2 className="text-xl pt-2 font-semibold mb-4">{heading}</h2>
          )}
          {children}
          {isShowAction && (
            <div className="mt-4 flex justify-between gap-4">
              <Button
                colorScheme="red"
                variant={"outline"}
                flexBasis={"50%"}
                className="bg-red-500 text-white px-4 py-2 rounded-md"
                onClick={onClose}
              >
                Cancel
              </Button>
              <PrimaryButton
                disabled={isDisbledSubmit}
                onClick={handleSubmit}
                flexBasis={"50%"}
                className="bg-blue-500 text-white px-4 py-2 rounded-md"
              >
                Confirm
              </PrimaryButton>
            </div>
          )}
        </div>
      </div>
    </div>
    // </div>
  );
};

export default PopupWrapper;
